import { Stack, Group, Text, Button, Paper, Center } from 'components'
import { ThemeIcon } from '@mantine/core'
import { IconPlus, IconCube } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { SelectedSkillStandard } from '../../../types'
import { SkillStandardCard } from './SkillStandardCard'

interface AddedSkillsListProps {
  items: SelectedSkillStandard[]
  onRemove: (id: string) => void
  onAddClick: () => void
  showCyclesBadges?: boolean
  disabled?: boolean
}

export const AddedSkillsList = ({ items, onRemove, onAddClick, showCyclesBadges, disabled }: AddedSkillsListProps) => {
  const { t } = useTranslation()

  const isEmpty = items.length === 0

  return (
    <Stack spacing="md">
      {/* Header */}
      <Group position="apart">
        <Text size="lg" weight={600}>
          {t('arc_added_standards_skills')} ({items.length})
        </Text>
        {!isEmpty && (
          <Button
            variant="filled"
            color="teal"
            leftIcon={<IconPlus size={16} />}
            onClick={onAddClick}
          >
            {t('arc_add_standards_skills')}
          </Button>
        )}
      </Group>

      {/* Lista de items ou empty state */}
      {isEmpty ? (
        <Paper
          p="xl"
          radius="md"
          sx={(theme) => ({
            backgroundColor: theme.colors.gray[0],
            minHeight: 200,
          })}
        >
          <Center h={200}>
            <Stack align="center" spacing="md">
              <ThemeIcon size={60} radius="xl" color="gray" variant="light">
                <IconCube size={30} />
              </ThemeIcon>
              <Text color="dimmed" align="center">
                {t('arc_empty_standards_skills')}
              </Text>
              <Button
                variant="filled"
                color="teal"
                leftIcon={<IconPlus size={16} />}
                onClick={onAddClick}
              >
                {t('arc_add_standards_skills')}
              </Button>
            </Stack>
          </Center>
        </Paper>
      ) : (
        <Stack spacing="sm">
          {items.map((item) => (
            <SkillStandardCard
              key={item.id}
              item={item}
              onRemove={onRemove}
              showCyclesBadges={showCyclesBadges}
              disabled={disabled}
            />
          ))}
        </Stack>
      )}
    </Stack>
  )
}
